import type { AppMaintenanceStatus, MaintenanceStatusApiResponse } from './types'

export type MaintenancePollResult =
    | { outcome: 'inMaintenance'; status: AppMaintenanceStatus }
    | { outcome: 'notInMaintenance' }
    | { outcome: 'requestFailed' }

export async function fetchMaintenanceStatusPoll(
    signal: AbortSignal,
    statusUrl: string,
): Promise<MaintenancePollResult> {
    const res = await fetch(statusUrl, { signal })
    if (!res.ok) {
        return { outcome: 'requestFailed' }
    }
    const data = (await res.json()) as MaintenanceStatusApiResponse
    const appStatus = data.currentAppStatus
    if (!appStatus?.enabled) {
        return { outcome: 'notInMaintenance' }
    }
    return { outcome: 'inMaintenance', status: appStatus }
}
